
import { defineComponent, ref } from "vue";
export default defineComponent({
  name: "NavDialog",
  setup() {
    const isShow = ref(false);
    const showFlag = ref(1);
    return { isShow, showFlag };
  }
});
